import VisibilityIcon from "@mui/icons-material/Visibility";
import { Divider, FormHelperText, Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { SalesTeamJson } from "../../DynamicFormsJson/MastersJSON/salesTeam";
import {
  getClaimStructureAllotmentBySalesTeam,
  getClaimTypeByClaimStructure,
} from "../../Slice/claim.slice";
import AttachFile from "../../components/Comman/AttachFile";
import AutoComplete from "../../components/Comman/AutoComplete";
import { ButtonCompo } from "../../components/Comman/Button";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import { LabelCompo } from "../../components/Comman/Label";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import RTTable from "../../components/Comman/RT/RTTable";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import { withRouter } from "../../components/withRouter";
import { redColor, titleColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import {
  atleastOne,
  deleteFailedMsg,
  deletemsg,
  deleteWarningMsg,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
  updateData,
  updateMsg,
} from "../../config/messageconstant";
import {
  apiDelete,
  apiGet,
  apiPost,
  apiPostForImage,
} from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import {
  getAuthorityWiseUnderSalesTeam,
  getUnderSalesTeamList,
} from "../../Slice/salesExecutive.slice";
import BasicDatePicker from "../../components/Comman/DatePickerEx";

class SalesTeamClaimForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowList: [],
      formErrors: {},
      fieldData: {},
      editData: {},
      editFlag: false,
      isLog: true,
      moduleObjDataObj: {},
      employee: "",
      claimStructure: "",
      claimTo: "",
      claimType: "",
      claimTitle: "",
      amount: "",
      description: "",
      noOfDays: "",
      isAttachmentApplicable: "",
      imageSelect: false,
      fileName: "",
      rowList: [],
      claimToObj: {},
      insertedUserIdHeader: "",
      matchedClaimType: {},
      dateForClaim: "",
      isAmountFreeze: false,
      dynamicMasterData: {
        claimStructureDetail: this.props.claimList?.claimStructureAllotment,
        claimTypeDetail: this.props.claimList?.claimType,
      },
    };
  }

  changeDate = (fieldName) => (date) => {
    this.setState({ [fieldName]: date });
  };

  async componentDidMount() {
    this.setState({
      rowList: [],
    });

    const {
      showLoador,
      showNotification,
      getUnderSalesTeamList,
      getAuthorityWiseUnderSalesTeam,
    } = this.props;
    if (navigator.onLine) {
      const moduleObjData = localStorage.getItem("moduleObj");
      const moduleObjDataObj =
        moduleObjData != null ? JSON.parse(moduleObjData) : {};

      const getClaimAuthorityWiseData = localStorage.getItem(
        "getClaimAuthorityWiseData"
      );

      this.setState({ moduleObjDataObj });

      if (this.props.params.id) {
        this.getDataById(this.props.params.id);
      }
      if (getClaimAuthorityWiseData == 1) {
        showLoador({ loador: true });
        await getAuthorityWiseUnderSalesTeam({ flag: 1 }).then(
          ({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              response.map((dataObj) => {
                return this.setState({
                  claimTo: dataObj.name,
                  claimToObj: dataObj,
                });
              });
            }
          }
        );
      } else {
        showLoador({ loador: true });
        await getUnderSalesTeamList().then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            response.map((dataObj) => {
              return this.setState({
                claimTo: dataObj.name,
                claimToObj: dataObj,
              });
            });
          }
        });
      }
    } else {
      showNotification({
        msg: noInternetMsg,
        severity: "error",
      });
    }
  }

  rowDelete = (rowData) => {
    const { showNotification, showLoador } = this.props;
    const { isLog, moduleObjDataObj } = this.state;
    swal({
      title: "Are you sure?",
      text: deleteWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const rowListData = this.state.rowList.filter(
          (row) => row.index != rowData.index
        );
        const row = rowListData.map((rowListDataObj, index) => {
          return { ...rowListDataObj, index: index + 1 };
        });
        this.setState({
          rowList: row,
        });
      }
    });
  };

  getDataById = () => {
    const {
      getClaimStructureAllotmentBySalesTeam,
      getClaimTypeByClaimStructure,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        const response = apiGet({
          url: endpoint.claimApplyHeader + "/" + this.props.params.id,
        }).then(async ({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            if (!data.error) {
              let rowData = data.data;

              let rowListById = [];

              if (rowData.claimApplyDetails.length !== 0) {
                rowListById = rowData.claimApplyDetails.map(
                  (dataObj, index) => {
                    return {
                      index: index + 1,
                      claimApplyDetailsId:
                        dataObj.id !== null ? dataObj.id : "-",
                      claimTitle: dataObj.name !== null ? dataObj.name : "-",
                      claimType:
                        dataObj.claimType !== null &&
                        dataObj.claimType.id !== null
                          ? dataObj.claimType.id
                          : "-",
                      claimTypeName:
                        dataObj.claimType !== null &&
                        dataObj.claimType.name !== null
                          ? dataObj.claimType.name
                          : "-",
                      amount:
                        dataObj.actualAmt !== null
                          ? Number(dataObj.actualAmt).toFixed(2)
                          : "-",
                      actualAmt:
                        dataObj.claimAmt !== null
                          ? Number(dataObj.claimAmt).toFixed(2)
                          : "-",
                      description:
                        dataObj.remark !== null ? dataObj.remark : "-",
                      fileName:
                        dataObj.attachFile !== null ? dataObj.attachFile : "",
                      insertedUserId:
                        dataObj.insertedUserId !== null
                          ? dataObj.insertedUserId
                          : "",
                    };
                  }
                );
              }

              let claimStructure =
                rowData.claimStructureHeader !== null &&
                rowData.claimStructureHeader.id !== null
                  ? rowData.claimStructureHeader.id
                  : "";

              let employee =
                rowData.salesTeam !== null && rowData.salesTeam.id !== null
                  ? rowData.salesTeam.id
                  : "";

              this.setState({
                editData: rowData,
                employee: employee,
                claimStructure,
                noOfDays: rowData.noOfDays || "",
                insertedUserIdHeader: rowData.insertedUserId,
                claimTitle: rowData.name !== null ? rowData.name : "",
                dateForClaim: rowData.date || "",
                rowList: rowListById,
              });

              showLoador({ loador: true });
              await getClaimStructureAllotmentBySalesTeam({
                salesTeamId: employee,
              }).then(({ success }) => {
                showLoador({ loador: false });
                if (!success) {
                  showNotification({ msg: serverMsg, severity: "error" });
                }
              });

              showLoador({ loador: true });
              await getClaimTypeByClaimStructure({
                claimStructureHeaderId: claimStructure,
              }).then(({ success }) => {
                showLoador({ loador: false });
                if (!success) {
                  showNotification({ msg: serverMsg, severity: "error" });
                }
              });

              return { data: rowData, success };
            }
            return { data: {}, success: false };
          } else {
            showNotification({ msg: serverMsg, severity: "error" });
          }

          return { data: {}, success: false };
        });
        return response;
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  checkValidation = () => {
    const {
      claimStructure,
      employee,
      claimType,
      claimTitle,
      claimTo,
      amount,
      description,
      isAttachmentApplicable,
      fileName,
      noOfDays,
      dateForClaim,
    } = this.state;

    let formErrors = {};
    let formIsValid = true;

    if (employee === null || employee === "") {
      formIsValid = false;
      formErrors["employeeError"] = "Please select employee";
    }

    if (claimStructure === null || claimStructure === "") {
      formIsValid = false;
      formErrors["claimStructureError"] = "Please select Claim Structure";
    }

    if (claimType === null || claimType === "") {
      formIsValid = false;
      formErrors["claimTypeError"] = "Please select claim Type";
    }

    if (claimTitle === null || claimTitle === "") {
      formIsValid = false;
      formErrors["claimTitleError"] = "Claim Title Required";
    }

    if (claimTo === null || claimTo === "") {
      formIsValid = false;
      formErrors["claimToError"] = "Claim To Required";
    }

    if (amount === "") {
      formIsValid = false;
      formErrors["amountError"] = "Actual Amount Required";
    }

    if (noOfDays === "") {
      formIsValid = false;
      formErrors["noOfDaysError"] = "No. of Days Required ";
    }

    if (dateForClaim === "") {
      formIsValid = false;
      formErrors["dateForClaim"] = "Date For Claim Required ";
    }

    if (description === "") {
      formIsValid = false;
      formErrors["descriptionError"] = "Description Required";
    }

    if (isAttachmentApplicable == 0 && (fileName === "" || fileName === null)) {
      formIsValid = false;
      formErrors["imageError"] = "Image Required";
    }

    this.setState({ formErrors: formErrors });
    return formIsValid;
  };

  changeHandlerForDropdown = (name, value) => {
    const {
      getClaimTypeByClaimStructure,
      getClaimStructureAllotmentBySalesTeam,
      claimList,
      showLoador,
      showNotification,
    } = this.props;

    let claimStructurevalue = this.state.claimStructure;

    if (name === "employee") {
      this.setState({
        employee: value,
        claimStructure: "",
        claimType: "",
        amount: "",
        description: "",
        fileName: "",
      });

      if (value && value !== "") {
        if (navigator.onLine) {
          showLoador({ loador: true });
          getClaimStructureAllotmentBySalesTeam({ salesTeamId: value }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
        } else {
          showNotification({ msg: noInternetMsg, severity: "error" });
        }
      }
    }

    if (name === "claimStructure") {
      this.setState({
        rowList: [],
        claimStructure: value,
        claimType: "",
        amount: "",
        description: "",
        fileName: "",
      });

      claimStructurevalue = value;

      if (value && value !== "") {
        if (navigator.onLine) {
          showLoador({ loador: true });
          getClaimTypeByClaimStructure({ claimStructureHeaderId: value }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
        } else {
          showNotification({ msg: noInternetMsg, severity: "error" });
        }
      }
    }

    if (name === "claimType") {
      this.setState({
        claimType: value,
      });

      claimList?.claimType.map((obj) => {
        if (obj.id === value) {
          this.setState({ isAttachmentApplicable: obj.attachmentApplicable });
        }
      });

      // find the matching claimType inside claimStructureAllotment
      let matchedClaimType = null;

      claimList?.claimStructureAllotment?.forEach((dataObj) => {
        if (dataObj.id == claimStructurevalue) {
          const foundDetail = dataObj.claimStructureDetails.find(
            (row) => row.claimType.id == value
          );
          if (foundDetail) {
            matchedClaimType = foundDetail;
          }
        }
      });

      console.log("matchedClaimType:", matchedClaimType);

      // if type = 1 and limitVal = 1, freeze amount
      if (
        matchedClaimType !== null &&
        matchedClaimType.claimType &&
        matchedClaimType.claimType.limitVal == 1 &&
        matchedClaimType.claimType.type == 1
      ) {
        this.setState({
          amount: matchedClaimType.claimAmt,
          isAmountFreeze: true,
        });
      } else {
        this.setState({
          isAmountFreeze: false,
          amount: "",
        });
      }

      this.setState({
        matchedClaimType,
      });
    }
  };

  changeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "claimTitle") {
      this.setState({
        claimTitle: value,
      });
    }

    if (name === "amount") {
      this.setState({ amount: value });
    }

    if (name === "description") {
      this.setState({ description: value });
    }
  };

  changeDaysHandler = (e) => {
    const { name, value } = e.target;
    this.setState({ noOfDays: value });
  };

  changeH = (fileName, name, index) => {
    this.setState({
      ...this.state,
      fileName: fileName,
    });

    this.setState({ imageSelect: true });
  };

  onClickViewPreview = (e, row) => {
    e.stopPropagation();
    const url = URL.createObjectURL(row);
    window.open(url);
  };

  onAdd = () => {
    const { claimList, showLoador, showNotification } = this.props;
    const {
      claimStructure,
      claimType,
      claimTitle,
      claimTo,
      amount,
      description,
      isAttachmentApplicable,
      fileName,
      rowList,
      matchedClaimType,
      noOfDays,
    } = this.state;

    if (this.checkValidation()) {
      if (matchedClaimType && matchedClaimType.claimType) {
        if (
          matchedClaimType.claimType.limitVal == 1 &&
          matchedClaimType.claimType.type == 2
        ) {
          if (amount > matchedClaimType.claimAmt) {
            this.props.showNotification({
              msg:
                "Amount should be less than or equal to " +
                matchedClaimType.claimAmt,
              severity: "error",
            });
            return;
          }
        }
      }

      let fileNameData = "";
      if (fileName && fileName !== "") {
        fileNameData =
          dayjs(fileName.lastModifiedDate).format("hh:mm:ss") + fileName.name;

        const formData = new FormData();
        formData.append("file", fileName);
        formData.append("imageName", fileNameData);

        showLoador({ loador: true });
        apiPostForImage({
          url: endpoint.uploadImage,
          postBody: formData,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
          } else {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }

      // const claimAmt = (parseFloat(amount) * parseInt(noOfDays)).toFixed(2);

      let claimAmt = amount ? Number(amount).toFixed(2) : "-";
      if (noOfDays > 0) {
        claimAmt = (parseFloat(amount) * parseInt(noOfDays)).toFixed(2);
      }

      let claimStructureList = claimList?.claimStructureAllotment.filter(
        (row) => row.id == claimStructure
      );

      let claimTypeList = claimList?.claimType.filter(
        (row) => row.id == claimType
      );

      let rowListJson = {
        index: rowList.length + 1,
        claimStructure:
          claimStructureList.length !== 0 ? claimStructureList[0].id : "-",
        claimStructureName:
          claimStructureList.length !== 0 ? claimStructureList[0].name : "-",
        claimTitle: claimTitle ? claimTitle : "-",
        claimType: claimTypeList.length !== 0 ? claimTypeList[0].id : "-",
        claimTypeName: claimTypeList.length !== 0 ? claimTypeList[0].name : "-",
        claimTo: claimTo ? claimTo : "-",
        amount: amount ? Number(amount).toFixed(2) : "-",
        actualAmt: claimAmt,
        description: description ? description : "-",
        fileName: fileNameData ? fileNameData : "",
      };

      this.setState({
        rowList: [...rowList, rowListJson],
        claimType: "",
        amount: "",
        description: "",
        fileName: "",
      });
    }
  };

  onSubmitData = () => {
    const { showLoador, showNotification } = this.props;
    const {
      claimStructure,
      claimType,
      claimTitle,
      claimTo,
      amount,
      description,
      isAttachmentApplicable,
      fileName,
      employee,
      rowList,
      claimToObj,
      insertedUserIdHeader,
      editData,
      noOfDays,
      dateForClaim,
    } = this.state;

    let userStockStakeHolderTypeId =
      localStorage.getItem("userStockStakeHolderTypeId") &&
      localStorage.getItem("userStockStakeHolderTypeId");

    let userId =
      localStorage.getItem("userId") && localStorage.getItem("userId");

    if (rowList.length != 0) {
      let dataToSave = {};

      let claimApplyDetailsList = rowList.map((dataObj) => {
        return {
          claimType: { id: dataObj.claimType },
          claimAmt: dataObj.actualAmt,
          actualAmt: dataObj.amount,
          attachFile: dataObj.fileName ? dataObj.fileName : null,
          remark: dataObj.description,
          isActive: 1,
        };
      });

      const formattedDate = dateForClaim
        ? dayjs(dateForClaim).format("DD-MM-YYYY")
        : "";

      if (this.props.params.id) {
        dataToSave = {
          id: this.props.params.id,
          name: claimTitle !== null ? claimTitle : "",
          salesTeam: { id: employee },
          claimStructureHeader: { id: claimStructure },
          projectId: null,
          noOfDays: parseInt(noOfDays),
          date: editData.date !== null ? editData.date : formattedDate,
          authoritySalesPersonId: userId !== null ? userId : "",
          authoritySalesPersonTypeId:
            userStockStakeHolderTypeId !== null
              ? userStockStakeHolderTypeId
              : "",
          status: 0,
          isActive: 1,
          insertedUserId: insertedUserIdHeader,
          claimLogId: null,
          claimApplyDetails: claimApplyDetailsList,
        };
      } else {
        dataToSave = {
          name: claimTitle !== null ? claimTitle : "",
          salesTeam: { id: employee },
          claimStructureHeader: { id: claimStructure },
          projectId: null,
          noOfDays: parseInt(noOfDays),
          date: formattedDate,
          authoritySalesPersonId: userId !== null ? userId : "",
          authoritySalesPersonTypeId:
            userStockStakeHolderTypeId !== null
              ? userStockStakeHolderTypeId
              : "",
          status: 2,
          isActive: 1,
          claimLogId: null,
          claimApplyDetails: claimApplyDetailsList,
        };
      }

      swal({
        title: "Are you sure?",
        text: this.props.params.id ? updateData : saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.onSave(dataToSave);
        }
      });
    } else {
      showNotification({
        msg: atleastOne,
        severity: "error",
      });
    }
  };

  onSave = (dataToSave) => {
    const { showLoador, showNotification } = this.props;
    const { isLog, moduleObjDataObj } = this.state;

    if (navigator.onLine) {
      showLoador({ loador: true });
      apiPost({
        url: this.props.params.id
          ? endpoint.claimApplyHeader + "/update"
          : endpoint.claimApplyHeader,
        postBody: dataToSave,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          showNotification({ msg: this.props.params.id ? updateMsg : savemsg });
          this.props.navigate(-1);
        } else {
          showNotification({ msg: saveFailedMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  render() {
    const {
      dynamicMasterData,
      formErrors,
      fieldData,
      open,
      editData,
      editFlag,
      claimStructure,
      claimType,
      claimTitle,
      amount,
      description,
      isAttachmentApplicable,
      fileName,
      imageSelect,
      rowList,
      employee,
      isAmountFreeze,
      noOfDays,
      dateForClaim,
    } = this.state;
    const { claimList, salesExecutiveList } = this.props;
    return (
      <>
        {!open && (
          <>
            <Paper
              sx={{
                padding: 2,
              }}
              elevation={0}
            >
              <LandingScreenHeader
                showTitle={true}
                screenTitle={"Sales Team Claim"}
                showSaveBtnMain={false}
                showAddButton={false}
                showBackButton={true}
                onCancel={() => this.props.navigate(-1)}
              />

              <br />

              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="space-between"
              >
                <Grid
                  item
                  sm={6}
                  xs={12}
                  md={6}
                  lg={6}
                  container
                  justifyContent="space-between"
                >
                  <Grid item xs={12} md={5} sm={5}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label="* "
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label="Date:"
                    />
                  </Grid>
                  <Grid item xs={12} md={7} sm={7}>
                    <BasicDatePicker
                      color="primary"
                      name="dateForClaim"
                      size="small"
                      value={dateForClaim}
                      disabled={false}
                      fullWidth
                      onChange={this.changeDate("dateForClaim")}
                      errorText={formErrors["dateForClaim"] || ""}
                      isError={formErrors["dateForClaim"] || ""}
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  sm={6}
                  xs={12}
                  md={6}
                  lg={6}
                  container
                  justifyContent="space-between"
                >
                  <Grid item xs={12} md={5} sm={5}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label="* "
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label="No. of Days:"
                    />
                  </Grid>
                  <Grid item xs={12} md={7} sm={7}>
                    <TextFieldCompo
                      placeHolder={"Enter No. of Days"}
                      color="primary"
                      name="noOfDays"
                      value={noOfDays}
                      fullWidth
                      onChange={this.changeDaysHandler}
                      type="number"
                      errorText={
                        formErrors["noOfDaysError"]
                          ? formErrors["noOfDaysError"]
                          : ""
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="space-between"
              >
                <Grid
                  item
                  sm={6}
                  xs={12}
                  md={6}
                  lg={6}
                  container
                  justifyContent="space-between"
                >
                  <Grid item xs={12} md={5} sm={5}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label="* "
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label="Employee:"
                    />
                  </Grid>
                  <Grid item xs={12} md={7} sm={7}>
                    <AutoComplete
                      keyColName={"id"}
                      placeHolder="Select Employee"
                      value={employee}
                      name={"employee"}
                      options={salesExecutiveList?.salesExecutive}
                      errorText={
                        formErrors["employeeError"]
                          ? formErrors["employeeError"]
                          : ""
                      }
                      isError={
                        formErrors["employeeError"]
                          ? formErrors["employeeError"]
                          : ""
                      }
                      onChange={this.changeHandlerForDropdown}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={6}
                  xs={12}
                  md={6}
                  lg={6}
                  container
                  justifyContent="space-between"
                >
                  <Grid item xs={12} md={5} sm={5}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label="* "
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label="Claim Title:"
                    />
                  </Grid>
                  <Grid item xs={12} md={7} sm={7}>
                    <TextFieldCompo
                      placeHolder={"Claim Title"}
                      color="primary"
                      name="claimTitle"
                      value={claimTitle}
                      fullWidth
                      onChange={this.changeHandler}
                      maxLength={10}
                      errorText={
                        formErrors["claimTitleError"]
                          ? formErrors["claimTitleError"]
                          : ""
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="space-between"
              >
                <Grid
                  item
                  sm={6}
                  xs={12}
                  md={6}
                  lg={6}
                  container
                  justifyContent="space-between"
                >
                  <Grid item xs={12} md={5} sm={5}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label="* "
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label="Claim Structure:"
                    />
                  </Grid>
                  <Grid item xs={12} md={7} sm={7}>
                    <AutoComplete
                      keyColName={"id"}
                      placeHolder="Select Claim Structure"
                      value={claimStructure}
                      name={"claimStructure"}
                      options={claimList?.claimStructureAllotment}
                      errorText={
                        formErrors["claimStructureError"]
                          ? formErrors["claimStructureError"]
                          : ""
                      }
                      isError={
                        formErrors["claimStructureError"]
                          ? formErrors["claimStructureError"]
                          : ""
                      }
                      onChange={this.changeHandlerForDropdown}
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  sm={6}
                  xs={12}
                  md={6}
                  lg={6}
                  container
                  justifyContent="space-between"
                >
                  <Grid item xs={12} md={5} sm={5}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label="* "
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label="Claim Type:"
                    />
                  </Grid>
                  <Grid item xs={12} md={7} sm={7}>
                    <AutoComplete
                      keyColName={"id"}
                      placeHolder="Select Claim Type"
                      value={claimType}
                      name={"claimType"}
                      options={claimList?.claimType}
                      errorText={
                        formErrors["claimTypeError"]
                          ? formErrors["claimTypeError"]
                          : ""
                      }
                      isError={
                        formErrors["claimTypeError"]
                          ? formErrors["claimTypeError"]
                          : ""
                      }
                      onChange={this.changeHandlerForDropdown}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="space-between"
              >
                <Grid
                  item
                  sm={6}
                  xs={12}
                  md={6}
                  lg={6}
                  container
                  justifyContent="space-between"
                >
                  <Grid item xs={12} md={5} sm={5}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label="* "
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label="Claim Amount:"
                    />
                  </Grid>
                  <Grid item xs={12} md={7} sm={7}>
                    <TextFieldCompo
                      placeHolder={"Actual Amount"}
                      color="primary"
                      name="amount"
                      value={amount}
                      fullWidth
                      onChange={this.changeHandler}
                      type="number"
                      errorText={
                        formErrors["amountError"]
                          ? formErrors["amountError"]
                          : ""
                      }
                      disabled={isAmountFreeze}
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  sm={6}
                  xs={12}
                  md={6}
                  lg={6}
                  container
                  justifyContent="space-between"
                >
                  <Grid item xs={12} md={5} sm={5}>
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: redColor }}
                      label="* "
                    />
                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label="Description:"
                    />
                  </Grid>
                  <Grid item xs={12} md={7} sm={7}>
                    <TextFieldCompo
                      placeHolder={"Description"}
                      color="primary"
                      name="description"
                      value={description}
                      fullWidth
                      onChange={this.changeHandler}
                      type="text"
                      errorText={
                        formErrors["descriptionError"]
                          ? formErrors["descriptionError"]
                          : ""
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="space-between"
              >
                <Grid
                  item
                  sm={6}
                  xs={12}
                  md={6}
                  lg={6}
                  container
                  justifyContent="space-between"
                >
                  <Grid item xs={12} md={5} sm={5}>
                    {isAttachmentApplicable == 0 && (
                      <>
                        <LabelCompo
                          className="text-black"
                          style={{ fontSize: 16, color: redColor }}
                          label="* "
                        />
                      </>
                    )}

                    <LabelCompo
                      className="text-black"
                      style={{ fontSize: 16, color: titleColor }}
                      label="Select Image:"
                    />
                  </Grid>
                  <Grid item xs={12} md={7} sm={7}>
                    <AttachFile name={"file"} fileName={this.changeH} />
                    &nbsp; {fileName !== "" ? fileName.name : ""}
                    &nbsp;{" "}
                    {fileName !== "" ? (
                      <MyComponentWithIconProps
                        statusImage={VisibilityIcon}
                        color="primary"
                        fontSize="medium"
                        title="View"
                        onClick={
                          this.props.params.id && imageSelect
                            ? (e) => this.onClickViewPreview(e, fileName)
                            : this.props.params.id
                            ? () => {
                                window.open(imageUrl + fileName.name, "_blank");
                              }
                            : (e) => this.onClickViewPreview(e, fileName)
                        }
                      />
                    ) : (
                      <FormHelperText error>
                        {formErrors["imageError"]
                          ? formErrors["imageError"]
                          : ""}
                      </FormHelperText>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="right"
              >
                <ButtonCompo
                  size="medium"
                  type="button"
                  variant="contained"
                  name="Add"
                  onClick={this.onAdd}
                />
              </Grid>

              <br />
              <RTTable
                showPegination={false}
                columns={[
                  { name: "index", title: "Sr. No.", align: "center" },
                  { name: "claimTypeName", title: "Claim Type" },
                  // { name: "amount", title: "Actual Amount", align: "right" },
                  { name: "actualAmt", title: "Amount", align: "right" },
                  { name: "action", title: "Action" },
                ]}
                tableData={rowList}
                isActionColActive={true}
                showEditIcon={false}
                showDeleteIcon={true}
                rowDelete={this.rowDelete}
              />
              <br />

              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="right"
              >
                <ButtonCompo
                  size="medium"
                  type="button"
                  variant="contained"
                  name="Submit"
                  onClick={this.onSubmitData}
                />
              </Grid>
            </Paper>
          </>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  claimList: state.claim,
  salesExecutiveList: state.salesExecutive,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getClaimStructureAllotmentBySalesTeam,
  getUnderSalesTeamList,
  getClaimTypeByClaimStructure,
  getAuthorityWiseUnderSalesTeam,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SalesTeamClaimForm);
